import { API_BASE_URL as API_URL } from './config';

function buildAdminRequestOptions(method, payload) {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`
  };

  const options = { method, headers };

  if (payload instanceof FormData) {
    options.body = payload;
    return options;
  }

  headers['Content-Type'] = 'application/json';
  options.body = JSON.stringify(payload);
  return options;
}

export const otherNewsAPI = {
  getOptions: async () => {
    const response = await fetch(`${API_URL}/other-news/options`);
    return response.json();
  },

  getNews: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.menuTitle) params.append('menuTitle', filters.menuTitle);
    if (filters.submenu) params.append('submenu', filters.submenu);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (typeof filters.isPublished !== 'undefined') {
      params.append('isPublished', String(filters.isPublished));
    }

    const response = await fetch(`${API_URL}/other-news?${params.toString()}`);
    return response.json();
  },

  getNewsById: async (id) => {
    const response = await fetch(`${API_URL}/other-news/id/${id}`);
    return response.json();
  },

  incrementView: async (id) => {
    const response = await fetch(`${API_URL}/other-news/id/${id}/view`, {
      method: 'POST'
    });
    return response.json();
  },

  incrementShare: async (id) => {
    const response = await fetch(`${API_URL}/other-news/id/${id}/share`, {
      method: 'POST'
    });
    return response.json();
  },

  getAdminNews: async () => {
    const response = await fetch(`${API_URL}/other-news/admin/all`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.json();
  },

  addNews: async (payload) => {
    const response = await fetch(
      `${API_URL}/other-news/admin/add`,
      buildAdminRequestOptions('POST', payload)
    );
    return response.json();
  },

  updateNews: async (id, payload) => {
    const response = await fetch(
      `${API_URL}/other-news/admin/${id}`,
      buildAdminRequestOptions('PUT', payload)
    );
    return response.json();
  },

  deleteNews: async (id) => {
    const response = await fetch(`${API_URL}/other-news/admin/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    return response.json();
  }
};

export default otherNewsAPI;
